import classNames from "classnames";
import { useEffect, useState, useLayoutEffect } from "react";
import { useSelector } from "react-redux";

import Sidebar, { LeftPanel } from "./../Sidebar/Sidebar";
import Header from "./../Header/Header";
import Footer from "./../Footer/Footer";

const PrivateLayoutFrame = ({ children }) => {
  const theme = useSelector((state) => state.theme);
  //Sidebar
  const [mobileView, setMobileView] = useState();
  const [visibility, setVisibility] = useState(false);
  const [currentMenuTab, setCurrentMenuTab] = useState("داشبورد");

  //Adds classes to body
  useEffect(() => {
    document.body.className = `nk-body ui-rounder has-sidebar has-touch nk-nio-theme ${
      visibility ? "nav-shown" : ""
    } ${theme.isDarkMode ? "dark-mode" : ""}`;
  }, [theme, visibility]);

  useEffect(() => {
    viewChange();
  }, []);

  // Stops scrolling on overlay
  useLayoutEffect(() => {
    if (visibility) {
      document.body.style.overflow = "hidden";
      document.body.style.height = "100%";
    }
    if (!visibility) {
      document.body.style.overflow = "auto";
      document.body.style.height = "auto";
    }
  }, [visibility]);

  // function to toggle sidebar
  const toggleSidebar = (e) => {
    e.preventDefault();
    if (visibility === false) {
      setVisibility(true);
    } else {
      setVisibility(false);
    }
  };

  // function to change the design view under 1200 px
  const viewChange = () => {
    if (window.innerWidth < 1200) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setVisibility(false);
    }
  };
  window.addEventListener("load", viewChange);
  window.addEventListener("resize", viewChange);

  const sidebarClass = classNames({
    "nk-sidebar": "true",
    "nk-sidebar-mobile": mobileView,
    "nk-sidebar-active": visibility && mobileView,
  });

  return (
    <div className="nk-app-root">
      <div className={sidebarClass}>
        <LeftPanel
          theme={theme.apps}
          setCurrentMenuTab={setCurrentMenuTab}
          setVisibility={setVisibility}
        />
        <Sidebar
          sidebarToggle={toggleSidebar}
          mobileView={mobileView}
          theme={theme.sidebar}
          currentMenuTab={currentMenuTab}
        />
      </div>
      {visibility && mobileView && (
        <div className="nk-sidebar-overlay" onClick={toggleSidebar}></div>
      )}
      <div className="nk-main">
        <div className="nk-wrap">
          <Header
            fixed
            sidebarToggle={toggleSidebar}
          />
          <div className="nk-content">
            <div className="container-fluid">
              <div className="nk-content-inner">
                <div className="nk-content-body">{children}</div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};
export default PrivateLayoutFrame;
